module.exports = __webpack_public_path__ + "assets/img/empty_cart@2x.8ef83c2a.png";